import React from "react"

const SnackbarContext = React.createContext(null)

export default SnackbarContext
